module.exports = __webpack_public_path__ + "src/gpap-lib/img/EXPERIMENTS.png";